import { apiStateReducer, filterStateReducer } from '@common/slices';
import { configureStore } from '@reduxjs/toolkit';

import appReducer from './app-settings/reducer';
import confirmationReducer from './confirmation/reducer';
import lovsReducer from './lovs/reducer';
import userReducer from './user/reducer';

import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const persistConfig = {
  key: 'filterState',
  storage,
  whitelist: [
    'businessPartner',
    'users',
    'persons',
    'providers',
    'proposal',
    'policy',
    'transferLinks',
    'transfers',
    'productionDistribution'
  ]
};

const persistedFilterReducer = persistReducer(
  persistConfig,
  filterStateReducer
);

const store = configureStore({
  reducer: {
    user: userReducer,
    confirmation: confirmationReducer,
    app: appReducer,
    apiState: apiStateReducer,
    filterState: persistedFilterReducer,
    lovs: lovsReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
export default store;
